export const Vercel = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="500"
      height="500"
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M230.653 52.6932C191.799 56.9501 155.267 71.9653 125.779 95.7264C115.794 103.776 99.4634 120.571 92.2654 130.168C71.755 157.567 58.6748 188.836 53.7213 222.504C52.0186 233.882 51.4768 255.63 52.5603 267.008C55.8111 300.521 66.492 331.48 83.9065 357.873C115.949 406.556 164.942 437.747 222.526 446.261C233.903 447.964 255.652 448.506 267.03 447.422C300.543 444.171 331.502 433.49 357.895 416.076C406.578 384.033 437.769 335.04 446.283 277.456C447.986 266.079 448.528 244.33 447.444 232.953C443.497 192.396 429.023 156.484 404.256 125.757C396.207 115.772 379.411 99.4415 369.814 92.2435C342.415 71.7331 311.379 58.8076 277.478 53.6994C268.113 52.3062 239.786 51.687 230.653 52.6932ZM301.007 234.423C327.864 281.404 349.845 319.948 349.845 320.103C349.845 320.257 305.806 320.412 251.937 320.412C198.068 320.412 154.029 320.257 154.029 320.025C154.029 319.406 251.782 148.512 252.014 148.821C252.092 148.899 274.228 187.443 301.007 234.423Z"
        fill="currentColor"
      />
    </svg>
  )
}
